import { NgModule } from '@angular/core';
import { ToothEditorV0Module } from './tooth-editor-v0.module';
import { ToothEditorV1Module } from './tooth-editor-v1.module';

@NgModule({
	imports: [ToothEditorV0Module, ToothEditorV1Module],
	exports: []
})
export class ToothEditorModule {}
